import React, { useContext } from 'react';
import StepCounter from '@/components/pages/assessments/common/StepCounter';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const DetailedProgressSummary = ({ detailedContent, lastStepMessage = '', currentStep, title, subtitle, totalSteps, ...props }) => {
  const { xt, t } = useContext(i18nContext);
  const { css } = useContext(displayContext);

  return (
    <>
      <Row className={`${css('assessment-progress-container')} pt-4`}>
        <Col className={`${css('assessment-column-padding')}`}>
          <StepCounter step={currentStep} total={totalSteps} lastStepMessage={lastStepMessage} />
          <h3 className={css('assessment-progress-title')}>{title}</h3>
          <StepCounter step={currentStep} total={totalSteps} type="progress" />
        </Col>
      </Row>
      {detailedContent?.length && (
        <Row className={`${css('assessment-progress-details-container')} mt-4 pt-4 pb-2`}>
          <Col className={`${css('assessment-column-padding')}`}>
            {detailedContent.map((d, index) => (
              <p
                key={`${currentStep}-${index}`}
                className={d.className || ''}
                dangerouslySetInnerHTML={{ __html: typeof d.text === 'string' ? t(d.text) : xt(d.text) }}
              ></p>
            ))}
          </Col>
        </Row>
      )}
    </>
  );
};

export default DetailedProgressSummary;
